module.exports = __webpack_public_path__ + "img/embodimetria_nosfondo.9d25b4ff.png";